import { Outlet } from "@tanstack/react-router"

export const Timelapses = () => {
  return <Outlet />
}
